"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OfferContent = void 0;
var _environment = require("@ori/environment");
var _staticApiClientReact = require("@ori/static-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../../../constants");
var _contexts = require("../../../../contexts");
var _models = require("../../../../models");
var _OfferProducts = require("../../../OfferProducts");
var _OfferSearch = require("../../OfferSearch");
var _DebugOffer = require("../DebugOffer");
var _LoadingOverlay = require("../LoadingOverlay");
var _OfferTag = require("../OfferTag");
var _Points = require("../Points");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Component to render offer info and products.
 */
const OfferContent = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    offer,
    totalRecords,
    updatingProducts,
    searchTerm
  } = (0, _contexts.useOfferDetail)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const offerSearchFeatureToggle = (0, _staticApiClientReact.useGetTenantFeatureToggle)(tenant, _constants.EnableOfferSearchFeatureToggle);
  const showSearch = !!offerSearchFeatureToggle.data?.isEnabled && totalRecords >= _constants.MIN_OFFER_SEARCH_ITEMS_COUNT || !!searchTerm;
  const isSingleOffer = totalRecords === 1 && !showSearch;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": `${getTestId(_models.TestId.Offer)}-${offer.choiceId}`,
    isSingleOffer: isSingleOffer,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      isSingleOffer: isSingleOffer,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferTag.OfferTag, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TruncatedText, {
        "data-testid": getTestId(_models.TestId.Title),
        variant: "h5",
        maxLines: 3,
        children: offer.offerTitle
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Points.Points, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.TruncatedText, {
        "data-testid": getTestId(_models.TestId.Description),
        maxLines: 5,
        children: offer.offerDescription
      }), showSearch ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferSearch.OfferSearch, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_DebugOffer.DebugOffer, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.OfferProductsWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LoadingOverlay.LoadingOverlay, {
        loading: updatingProducts
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_OfferProducts.OfferProducts, {})]
    })]
  });
};
exports.OfferContent = OfferContent;